module.exports = __webpack_public_path__ + "f0feedefc17f4a5fa47e4538662eb752.pdf";